// Must match grid-auto-rows in Tabs.Masonry.scss
const ROW_HEIGHT = 2;

export default class TabsMasonry {
    static init() {
        if (!('ResizeObserver' in window)) {
            return;
        }

        Array.prototype.forEach.call(document.querySelectorAll('.tabs--masonry'), el => {
            new TabsMasonry(el);
        });
    }

    constructor(el) {
        this._content = el.querySelector('.tabs__content')
        if (!this._content) {
            return;
        }

        this._content.style.height = `${this._content.offsetHeight}px`

        this._resizeObserver = new ResizeObserver(entries => {
            let revealIndex = 0
            for (const entry of entries) {
                const item = entry.target
                const height = item.getBoundingClientRect().height
                // Inactive tab: reset so the item animates in again
                if (!height) {
                    item.classList.remove('is-positioned')
                    continue
                }

                this.updateItemRowSpan(item, height)
                if (!item.classList.contains('is-positioned')) {
                    this.revealItem(item, revealIndex++)
                }
            }
            this.updateContentHeight()
        })

        for (const contentItem of this._content.children) {
            for (const item of contentItem.children) {
                this._resizeObserver.observe(item)
            }
        }
    }

    updateItemRowSpan(item, height) {
        const gap = parseFloat(getComputedStyle(item.parentElement).columnGap) || 0
        item.style.gridRowEnd = `span ${Math.ceil((height + gap) / ROW_HEIGHT)}`
    }

    revealItem(item, index) {
        item.style.setProperty('--tabs-masonry-reveal-index', index)
        item.classList.add('is-positioned')
    }

    updateContentHeight() {
        const activeItem = this._content.querySelector('.tabs__content__item--active')
        if (!activeItem) {
            return;
        }

        this._content.style.height = `${activeItem.offsetHeight}px`
    }
}
